(function(ws) {
    'use strict';

    ws.views.stickyContainer = Backbone.View.extend({

        /**
         * Initialize module
         */
        initialize: function() {
            this.render();
        },

        /**
         * Render view
         */
        render: function() {
            var $el = this.$el;
            var offset = $el.offset().top;

            $(window).on('scroll', function() {
                var scrollTop = $(this).scrollTop();
                if (scrollTop > offset) {
                    $el.addClass('fixed');
                } else {
                    $el.removeClass('fixed');
                }
            });
        }

    });
}(westcon));
